"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var Http = require("http");

var Url = require("url");

var authorization_request_handler_1 = require("../authorization_request_handler");

var authorization_response_1 = require("../authorization_response");

var logger_1 = require("../logger");

var query_string_utils_1 = require("../query_string_utils");

var crypto_utils_1 = require("./crypto_utils"); // TypeScript typings for `opener` are not correct and do not export it as module


var opener = require("opener");

var ServerEventsEmitter =
/** @class */
function (_super) {
  __extends(ServerEventsEmitter, _super);

  function ServerEventsEmitter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ServerEventsEmitter.ON_UNABLE_TO_START = 'unable_to_start';
  ServerEventsEmitter.ON_AUTHORIZATION_RESPONSE = 'authorization_response';
  return ServerEventsEmitter;
}(events_1.EventEmitter);

var NodeBasedHandler =
/** @class */
function (_super) {
  __extends(NodeBasedHandler, _super);

  function NodeBasedHandler( // default to port 8000
  httpServerPort, utils, crypto) {
    if (httpServerPort === void 0) {
      httpServerPort = 8000;
    }

    if (utils === void 0) {
      utils = new query_string_utils_1.BasicQueryStringUtils();
    }

    if (crypto === void 0) {
      crypto = new crypto_utils_1.NodeCrypto();
    }

    var _this = _super.call(this, utils, crypto) || this;

    _this.httpServerPort = httpServerPort; // the handle to the current authorization request

    _this.authorizationPromise = null;
    return _this;
  }

  NodeBasedHandler.prototype.performAuthorizationRequest = function (configuration, request) {
    var _this = this; // use opener to launch a web browser and start the authorization flow.
    // start a web server to handle the authorization response.


    var emitter = new ServerEventsEmitter();

    var requestHandler = function requestHandler(httpRequest, response) {
      if (!httpRequest.url) {
        return;
      }

      var url = Url.parse(httpRequest.url);
      var searchParams = new Url.URLSearchParams(url.query || '');
      var state = searchParams.get('state') || undefined;
      var code = searchParams.get('code');
      var error = searchParams.get('error');

      if (!state && !code && !error) {
        // ignore irrelevant requests (e.g. favicon.ico)
        return;
      }

      logger_1.log('Handling Authorization Request ', searchParams, state, code, error);
      var authorizationResponse = null;
      var authorizationError = null;

      if (error) {
        logger_1.log('error'); // get additional optional info.

        var errorUri = searchParams.get('error_uri') || undefined;
        var errorDescription = searchParams.get('error_description') || undefined;
        authorizationError = new authorization_response_1.AuthorizationError({
          error: error,
          error_description: errorDescription,
          error_uri: errorUri,
          state: state
        });
      } else {
        authorizationResponse = new authorization_response_1.AuthorizationResponse({
          code: code,
          state: state
        });
      }

      var completeResponse = {
        request: request,
        response: authorizationResponse,
        error: authorizationError
      };
      emitter.emit(ServerEventsEmitter.ON_AUTHORIZATION_RESPONSE, completeResponse);
      response.end('Close your browser to continue');
    };

    this.authorizationPromise = new Promise(function (resolve, reject) {
      emitter.once(ServerEventsEmitter.ON_UNABLE_TO_START, function () {
        reject("Unable to create HTTP server at port " + _this.httpServerPort);
      });
      emitter.once(ServerEventsEmitter.ON_AUTHORIZATION_RESPONSE, function (result) {
        server.close(); // resolve pending promise

        resolve(result); // complete authorization flow

        _this.completeAuthorizationRequestIfPossible();
      });
    });
    var server;
    request.setupCodeVerifier().then(function () {
      server = Http.createServer(requestHandler);
      server.listen(_this.httpServerPort);

      var url = _this.buildRequestUrl(configuration, request);

      logger_1.log('Making a request to ', request, url);
      opener(url);
    }).catch(function (error) {
      logger_1.log('Something bad happened ', error);
      emitter.emit(ServerEventsEmitter.ON_UNABLE_TO_START);
    });
  };

  NodeBasedHandler.prototype.completeAuthorizationRequest = function () {
    if (!this.authorizationPromise) {
      return Promise.reject('No pending authorization request. Call performAuthorizationRequest() ?');
    }

    return this.authorizationPromise;
  };

  return NodeBasedHandler;
}(authorization_request_handler_1.AuthorizationRequestHandler);

exports.NodeBasedHandler = NodeBasedHandler;